module.exports = __webpack_public_path__ + "static/media/thumb-alastair.de1a4444.png";